<template>
  <svg
    width="33"
    height="34"
    viewBox="0 0 33 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_393_4898)">
      <path
        opacity="0.3"
        d="M16.5 33.5C22.1954 33.5 26.8125 32.8074 26.8125 31.9531C26.8125 31.0988 22.1954 30.4062 16.5 30.4062C10.8046 30.4062 6.1875 31.0988 6.1875 31.9531C6.1875 32.8074 10.8046 33.5 16.5 33.5Z"
        fill="black"
      />
      <path
        d="M22.1529 15.9687L26.348 11.7741C27.1534 10.9687 27.1534 9.66266 26.348 8.85725L23.6121 6.12134C22.8067 5.31594 21.5006 5.31594 20.6952 6.12134L16.5001 10.3165L12.3049 6.12134C11.4995 5.31594 10.1935 5.31594 9.38806 6.12134L6.65215 8.85725C5.84674 9.66266 5.84674 10.9687 6.65215 11.7741L10.8473 15.9687L6.65267 20.1634C5.84726 20.9688 5.84726 22.2748 6.65267 23.0802L9.38806 25.8162C10.1935 26.6216 11.4995 26.6216 12.3049 25.8162L16.5001 21.6215L20.6952 25.8162C21.5006 26.6216 22.8067 26.6216 23.6121 25.8162L26.3475 23.0802C27.1529 22.2748 27.1529 20.9688 26.3475 20.1634L22.1529 15.9687Z"
        fill="#FD3C4F"
      />
      <path
        opacity="0.15"
        d="M20.6946 25.8162C21.5 26.6216 22.8061 26.6216 23.6115 25.8162L26.3474 23.0802C27.1528 22.2748 27.1528 20.9688 26.3474 20.1634L22.1523 15.9688L23.975 14.146C23.4718 13.6423 22.8123 13.3906 22.1523 13.3906C21.5212 13.3906 20.89 13.6211 20.3961 14.0816C19.3215 15.0834 19.3787 16.8412 20.4177 17.8797L24.1596 21.621L22.1528 23.6278L18.4016 19.8772C17.4493 18.9248 15.9029 18.7707 14.8644 19.6276C13.6733 20.6109 13.6104 22.378 14.6762 23.4443L16.4995 21.621L20.6946 25.8162Z"
        fill="black"
      />
      <path
        opacity="0.3"
        d="M12.3049 6.12134C11.4995 5.31594 10.1935 5.31594 9.38806 6.12134L6.65215 8.85725C5.84674 9.66266 5.84674 10.9687 6.65215 11.7741L10.8473 15.9687L9.02454 17.7915C9.52779 18.2952 10.1873 18.5469 10.8473 18.5469C11.4784 18.5469 12.1095 18.3164 12.6035 17.8559C13.6781 16.8541 13.6208 15.0963 12.5818 14.0578L8.83995 10.3165L10.8468 8.30966L14.5979 12.0603C15.5503 13.0122 17.0967 13.1668 18.1351 12.3099C19.3262 11.3266 19.3891 9.55953 18.3233 8.49322L16.5001 10.3165L12.3049 6.12134Z"
        fill="white"
      />
      <path
        d="M9.53906 8.49219L10.8281 7.20312L12.1172 8.49219"
        stroke="white"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_393_4898">
        <rect
          width="33"
          height="33"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
